import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";
import CreateServiceOrder from "./components/create/CreateServiceOrder";
import { DetailLanding } from "./components/detail/Landing";

export interface DispatcherSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: DispatcherSetupRoute[];
}

export const dispatcherSetupRoutes: DispatcherSetupRoute[] = [
  {
    path: "/service-orders/dispatcher",
    element: <Landing />,
  },
  // ✅ Meter Service Order Route
  {
    path: "/service-orders/dispatcher/assigned-meter-service-order/:id",
    element: <DetailLanding />,
    auth: true, // Add auth if needed
  },
  // ✅ Consumer Service Order Route
  {
    path: "/service-orders/dispatcher/assigned-consumer-service-order/:id",
    element: <DetailLanding />,
    auth: true,
  },
  // ✅ Asset Service Order Route
  {
    path: "/service-orders/dispatcher/assigned-asset-service-order/:serviceType/:id",
    element: <DetailLanding />,
    auth: true,
  },
  {
    path: "/service-orders/wx-dashboard/create-service-order",
    element: <CreateServiceOrder />,
  },
  {
    path: "/service-orders/dispatcher/pending-meter-service-order/:id",
    element: <DetailLanding />,
    auth: true, // Add auth if needed
  },
  // ✅ Consumer Service Order Route
  {
    path: "/service-orders/dispatcher/pending-consumer-service-order/:id",
    element: <DetailLanding />,
    auth: true,
  },
  // ✅ Asset Service Order Route
  {
    path: "/service-orders/dispatcher/pending-asset-service-order/:serviceType/:id",
    element: <DetailLanding />,
    auth: true,
  },
  {
    path: "/service-orders/dispatcher/completed-meter-service-order/:id",
    element: <DetailLanding />,
  },
  // ✅ Consumer Service Order Route
  {
    path: "/service-orders/dispatcher/completed-consumer-service-order/:id",
    element: <DetailLanding />,
  },
  // ✅ Asset Service Order Route
  {
    path: "/service-orders/dispatcher/completed-asset-service-order/:serviceType/:id",
    element: <DetailLanding />,
  },
  {
    path: "/service-orders/dispatcher/completed-facility-service-order/:id",
    element: <DetailLanding />,
  },

 
 {
    path: " /service-orders/dispatcher/completed-service-order/:id",
    element: <DetailLanding />,
  },
  {
    path: "/service-orders/dispatcher/history-service-order/:id",
    element: <DetailLanding />,
  },
  
    {
    path: "/service-orders/dispatcher/rejected-service-order/:id",
    element: <DetailLanding />,
    },
  {
    path: "/service-orders/dispatcher/history-asset-service-order/:serviceType/:id",
    element: <DetailLanding />,
  },
  // ✅ Consumer Service Order Route
];
